<template>
  <div v-if="$store.getters.isAgent === true" style="background-color: #fff; padding-left: 2.5%; padding-right: 2.5%; padding-bottom: 10vh; padding-top: 15vh;">
    <!-- {{ $store.getters.userID }} -->

    <div class="vld-parent"> <!-- This div is for the loading overlay -->

      <h2 style="text-align: center;">Welcome to {{ $store.getters.agencyHumanName }} Mission Control</h2>
      <hr>

      <div v-if="agent.id">
        <div v-if="agent.category == 'global' || agent.agency == 1">
          <multiselect class="mb-3" v-model="selector" :options="selectorOptions" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
        </div>

        <div v-if="agent.category == 'candidates'">
          <multiselect class="mb-3" v-model="selector" :options="selectorOptions2" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
        </div>

        <!-- <select v-if="agent.category == 'global' || agent.agency == 1" class="form-control mt-4" v-model="selector" style="max-width: 200px;">
          <option>Master Calendar</option>
          <option>Nannies</option>
          <option>Clients</option>
          <option>Email Log</option>
          <option>Administrators</option>
          <option>Payments</option>
        </select> -->

        <!-- <select v-if="agent.category == 'candidates'" class="form-control mt-4" v-model="selector" style="max-width: 200px;">
          <option>Nannies</option>
        </select> -->
      </div>

      <div v-if="selector == 'Snapshot'">
        <div v-if="candidates.length > 0">
          <h4 class="ml-2 mt-2" style="margin-bottom: 0;">Nannies</h4>
          <status-stats :users="candidates" :statuses="$store.getters.candidateStatuses" key="candidateSnapshot"></status-stats>
          <hr>
        </div>

        <div v-if="employers.length > 0">
          <h4 class="ml-2 mt-2" style="margin-bottom: 0;">Clients</h4>
          <status-stats :users="employers" :statuses="$store.getters.employerStatuses" key="employerSnapshot"></status-stats>
          <hr>
        </div>
      </div>

      <div v-if="selector == 'Nannies'">
        <div v-if="candidates.length > 0">
          <!-- <h4 class="ml-2 mt-2" style="margin-bottom: 0;">Client Stats</h4> -->
          <status-stats :users="candidates" :statuses="$store.getters.candidateStatuses" key="candidateStats"></status-stats>
          <hr>
        </div>

        <div>
          <add-user :userType="'candidate'" @candidateAdded="getCandidates()"></add-user>
        </div>

        <div class="row">
          <div class="col-lg-3 mt-2">
            <!-- <label class="filter-label">Statuses</label> -->
            <multiselect v-model="statusFilters" :options="$store.getters.candidateStatuses" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Status"></multiselect>
          </div>
          <div class="col-lg-3 mt-2">
            <multiselect v-model="positionFilters" :options="$store.getters.positions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Positions"></multiselect>
          </div>
          <div class="col-lg-3 mt-2">
            <div class="form-group form-check pt-1">
              <input class="form-check-input" type="checkbox" :value="true" v-model="hideRejected" style="margin-top: 4px;">
              <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="hideRejected = !hideRejected">
                Hide Rejected Candidates
              </label>
            </div>
          </div>
          <div class="col-lg-3 mt-2">
            <button class="mylisting-button dark-button" @click="sortAlpha(candidates)">Sort Alphabetically</button>
            <button class="mylisting-button secondary-button" style="float: right;" @click="refresh()">Refresh</button>
          </div>

          <div class="col-lg-3 mt-2">
            <input type="text" class="form-control" v-model="candidateSearch" placeholder="Search by Name or Email">
          </div>
          <div class="col-lg-3 mt-2">
            <input type="text" class="form-control" v-model="languageSearch" placeholder="Search by Language">
          </div>
          <div class="col-lg-3 mt-2">
            <input type="text" class="form-control" v-model="stateSearch" placeholder="Search by State">
          </div>
          <div class="col-lg-3 mt-2">
            <multiselect v-model="liveinoutFilters" :options="$store.getters.availabilityOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Positions"></multiselect>
          </div>
        </div>
        <!-- <button class="mylisting-button secondary-button" @click="showEmailModal()">Email</button> -->
        <!-- <button class="mylisting-button dark-button" @click="updateStats()">Update Stats</button> -->
        <table class="table table-striped mt-2 shadow">
          <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
            <tr class="">
              <!-- <th scope="col">Score</th> -->
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <!-- <th scope="col">City</th> -->
              <!-- <th scope="col">State</th> -->
              <th scope="col">Positions Applied</th>
              <th scope="col">Languages</th>
              <th scope="col">Live In/Out</th>
              <th scope="col">State</th>
              <th scope="col">Applied</th>
              <th scope="col">Status</th>
              <!-- <th scope="col">Last Contacted</th> -->
              <!-- <th scope="col">Tags</th> -->
            </tr>
          </thead>
          <tbody>
            <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="showCandidateModal(user)" style="cursor: pointer;"> -->
            <tr v-for="user in filteredCandidates" :key="user.id" @click="showCandidateModal(user)" :class="{ 'newEntryRow' : user.status == 'Applied'}" style="cursor: pointer;">
            <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
              <!-- <td>
                <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
              </td> -->
              <!-- <td>
                <p>{{ user.integer1 }}</p>
              </td> -->
              <td>
                <!-- <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="margin-right: 15px;"> -->
                {{ user.first_name }} {{ user.last_name }}
                <!-- {{ user.status }} -->
                <!-- {{ user.id }} -->
              </td>
              <td>
                <p>{{ user.email }}</p>
              </td>
              <!-- <td>
                <p>{{ user.preferences.join(', ') }}</p>
              </td> -->
              <!-- <td>
                <p>{{ user.city }}<span v-if="user.provincestate">, </span>{{ user.provincestate }}<span v-if="user.country">, </span>{{ user.country }}</p>
              </td> -->
              <!-- <td>
                <p>{{ user.city }}</p>
              </td>
              <td>
                <p>{{ user.provincestate }}</p>
              </td> -->
              <td>
                <p v-if="user.multiselect2[0]">{{ user.multiselect2.join(', ') }}</p>
              </td>
              <td>
                <p>{{ user.selector2 }}</p>
              </td>
              <td>
                <p>{{ user.selector3 }}</p>
              </td>
              <td>
                <p>{{ user.provincestate }}</p>
              </td>
              <td>
                <p v-if="user.created_date">{{ new Date(user.created_date).toDateString() }}</p>
              </td>
              <td>
                <p>{{ user.status }}</p>
              </td>
              <!-- <td>
                <p>{{ new Date(user.last_contacted_date).toDateString() }}</p>
              </td> -->
              <!-- <td> -->
                <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
                <!-- <button class="mylisting-button dark-button" @click="adminify(user)">adminify</button> -->
                <!-- <button class="btn btn-danger" @click="setteam(user)">Set Team Status</button> -->
              <!-- </td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="selector == 'Clients'">
        <div v-if="employers.length > 0">
          <!-- <h4 class="ml-2 mt-2" style="margin-bottom: 0;">Client Stats</h4> -->
          <status-stats :users="employers" :statuses="$store.getters.employerStatuses" key="employerStats"></status-stats>
          <hr>
        </div>

        <div>
          <add-user :userType="'employer'" @employerAdded="getEmployers()"></add-user>
        </div>

        <div class="row">
          <div class="col-lg-3 mt-2">
            <multiselect v-model="employerStatusFilters" :options="$store.getters.employerStatuses" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Statuses"></multiselect>
          </div>
          <div class="col-lg-3 mt-2">
            <div class="form-group form-check pt-1">
              <input class="form-check-input" type="checkbox" :value="true" v-model="hideRejected" style="margin-top: 4px;">
              <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="hideRejected = !hideRejected">
                Hide Inactive and Lost Clients
              </label>
            </div>
            <div class="form-group form-check">
              <input class="form-check-input" type="checkbox" :value="true" v-model="hideCompleted" style="margin-top: 4px;">
              <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="hideCompleted = !hideCompleted">
                Hide Completed Clients
              </label>
            </div>
          </div>
          <div class="col-lg-3 mt-2">

          </div>
          <div class="col-lg-3 mt-2">
            <button class="mylisting-button secondary-button" style="float: right;" @click="refresh()">Refresh</button>
          </div>

          <div class="col-lg-12 mt-2">
            <input type="text" class="form-control" v-model="clientSearch" placeholder="Search by Name or Email">
          </div>
        </div>

        <table v-if="selector == 'Clients'" class="table table-striped mt-2">
          <!-- {{ employerEmails }} -->
          <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
            <tr>
              <th scope="col">Name</th>
              <!-- <th scope="col">Status</th> -->
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">City</th>
              <th scope="col">State</th>
              <!-- <th scope="col">Position(s)</th> -->
              <th scope="col">Service Type</th>
              <th scope="col">Entered</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr v-for="user in filteredEmployers" :key="user.id" @click="showEmployerModal(user)" :class="{ 'newEntryRow' : user.status == 'Applied', 'activeEntryRow' : user.status == 'Consultation Complete' || user.status == 'Nanny Assigned' }" style="cursor: pointer;"> -->
            <tr v-for="user in filteredEmployers" :key="user.id" @click="showEmployerModal(user)" :class="{ 'newEntryRow' : user.status == 'Applied' }" style="cursor: pointer;">
            <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
              <td>
                <!-- {{ user.employer_name }} -->
                <!-- {{ user.status }} -->
                {{ user.first_name }} {{ user.last_name }}
              </td>
              <td>
                {{ user.email }}
              </td>
              <td>
                {{ user.phone }}
              </td>
              <td>
                <p>{{ user.city }}</p>
              </td>
              <td>
                {{ user.provincestate }}
              </td>
              <!-- <td>
                {{ user.job_types.join(', ') }}
              </td> -->
              <td>
                {{ user.selector1 }}
              </td>
              <td>
                <p v-if="user.created_date">{{ new Date(user.created_date).toDateString() }}</p>
              </td>
              <td>
                <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
                <!-- <button v-if="user.status != 'Active'" class="btn btn-primary ml-4" @click="approveUser(user)">Activate</button> -->
                <!-- <button v-if="user.status == 'Active'" class="btn btn-secondary ml-4" @click="disapproveUser(user)">Deactivate</button> -->
                <!-- <button class="btn btn-danger ml-4" @click="changeEmail(user)">Change Email</button> -->
                <!-- <p v-if="user.status == 'Active'">Active</p> -->
                <!-- <p v-if="user.status != 'Active'">Inactive</p> -->
                {{ user.status }}
                <!-- {{ user.available_date }} -->
              </td>
              <!-- <td>
                {{ user.selector1 }}
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="selector == 'Jobs'">
        <!-- <jobs></jobs> -->
        <job-posting></job-posting>
      </div>

      <div v-if="selector=='Email Templates'">
        <email-templates></email-templates>
      </div>

      <div v-if="selector=='Email Footers'">
        <email-footers></email-footers>
      </div>

      <div v-if="selector == 'Email Log'">
        <email-log></email-log>
      </div>

      <div v-if="selector=='Document Templates'">
        <document-templates></document-templates>
      </div>

      <div v-if="selector=='Interview Templates'">
        <interview-templates></interview-templates>
      </div>

      <div v-if="selector=='Resource Manager'">
        <resource-manager></resource-manager>
      </div>

      <div v-if="selector == 'Blog'">
        <app-blog></app-blog>
      </div>

      <div v-if="selector == 'My Profile'">
        <app-candidate-profile></app-candidate-profile>
      </div>

      <div v-if="selector == 'My Events'">
        <div class="mt-4 container">
          <app-my-events :userID="$store.getters.userID"></app-my-events>
        </div>
      </div>

      <div v-if="selector == 'All Events'">
        <app-events></app-events>
      </div>

      <div v-if="selector == 'Administrators'">
        <app-agents></app-agents>
      </div>

      <div v-if="selector == 'Mailing List'">
        <app-mailing-list></app-mailing-list>
      </div>

      <div v-if="selector == 'Master Calendar'">
        <master-calendar></master-calendar>
      </div>

      <div v-if="selector == 'Payments'" class="mt-2">
        <!-- {{ agent.stripe_customer_id }} -->
        <!-- <button class="mylisting-button dark-button mt-2" @click="clearStripeID()">Clear Stripe ID</button> -->
        <!-- <p>{{ agent }}</p> -->
        <!-- <p>{{ agent.stripe_customer_id }}</p> -->

        <div v-if="!agent.stripe_customer_id">

          <!-- <a href="https://connect.stripe.com/oauth/authorize?response_type=code&redirect_uri=http://localhost:8080/stripe-connect-confirmation&client_id=ca_GSLne6oBUl21m0wMuIzFzXyw6EsCueSu&scope=read_write&state=300387032" target="_blank"> -->
          <a href="https://connect.stripe.com/oauth/authorize?response_type=code&redirect_uri=https://tinytreasuresnyc.enginehire.io/stripe-connect-confirmation&client_id=ca_GSLnGgAImYEcEPhXudAbksZuhK7R6e39&scope=read_write&state=300387032" target="_blank">
            <img src="../../assets/img/stripe/light-on-light@2x.png" alt="Stripe" width="200px" class="mt-2">
          </a>
        </div>

        <div v-if="agent.stripe_customer_id">
          <h4 class="mt-4">Your account has been successfully connected with Stripe.</h4>
          <!-- <button class="mylisting-button dark-button mt-2" @click="viewStripeDashboard()">View Stripe Dashboard</button> -->
        </div>

      </div>

      <modal name="candidate-modal" width="95%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">

          <div class="row" style="margin-bottom: 30px;">
            <div class="col dashboard-button" :class="{ 'dashboard-button-active': tab == 'admin' }" @click="tab = 'admin'">
              Admin
            </div>
            <!-- <div class="col-lg-4 col-md-4 dashboard-button" :class="{ 'dashboard-button-active': tab == 'schedule' }" @click="tab = 'schedule'">
              Scheduling
            </div> -->
            <div class="col dashboard-button" :class="{ 'dashboard-button-active': tab == 'profile' }" @click="tab = 'profile'">
              Profile
            </div>
            <div class="col dashboard-button" :class="{ 'dashboard-button-active': tab == 'interview' }" @click="tab = 'interview'">
              Interview
            </div>
            <!-- <div class="col dashboard-button" :class="{ 'dashboard-button-active': tab == 'jobs' }" @click="tab = 'jobs'">
              Jobs
            </div> -->
            <div class="col dashboard-button" :class="{ 'dashboard-button-active': tab == 'emails' }" @click="tab = 'emails'">
              Email Log
            </div>

          </div>

          <div v-if="tab == 'admin' && user.id">
            <panel :passedUser="user" @userUpdated="userUpdated()"></panel>
            <hr>
            <document-manager :user="user"></document-manager>
            <!-- <hr>
            <p>Number of Broadcasts Received: {{ user.numberArray[0] }}</p>
            <p>Number of Acceptances: {{ user.numberArray[1] }}</p>
            <p>Number of Declines: {{ user.numberArray[2] }}</p>
            <p>Number of Maybes: {{ user.numberArray[3] }}</p> -->
          </div>

          <div v-if="tab == 'schedule' && user.id">
            <scheduler :passedUser="user" :employers="employerEmails" @userUpdated="userUpdated()"></scheduler>
          </div>

          <div v-if="tab == 'profile'" style="margin-top: -80px; margin-bottom: -17.5vh;">
            <!-- <app-candidate-profile :userID="user.id"></app-candidate-profile> -->
            <candidate-dashboard :userID="user.id"></candidate-dashboard>
          </div>

          <div v-if="tab == 'interview' && user.id">
            <candidate-interview :userID="user.id" @userUpdated="userUpdated()"></candidate-interview>
          </div>

          <div v-if="tab == 'jobs' && user.id">
            <job-applications :user="user" @userUpdated="userUpdated()"></job-applications>
          </div>

          <div v-if="tab == 'emails' && user.id">
            <email-log :recipient="user"></email-log>
          </div>

          <hr>
          <!-- <button class="mylisting-button dark-button" @click="resetPassword(user)" style="">Reset Password</button> -->
          <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->

          <!-- <button v-if="user.status != 'Active'" class="mylisting-button dark-button" @click="approveUser(user)" style="float: right;">Activate</button> -->
          <!-- <button v-if="user.status == 'Active'" class="mylisting-button secondary-button" @click="disapproveUser(user)" style="float: right;">Deactivate</button> -->
          <button class="mylisting-button secondary-button" @click="hideUserModal()" style="">Close</button>
          <button class="mylisting-button danger-button" style="float: right;" @click="showDeleteUserModal(user)">Delete User</button>
        </div>
      </modal>

      <modal name="employer-modal" width="95%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">

          <div class="row" style="margin-bottom: 30px;">
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'admin' }" @click="tab = 'admin'">
              Admin
            </div>
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'application' }" @click="tab = 'application'">
              Profile
            </div>
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'documents' }" @click="tab = 'documents'">
              Documents
            </div>
            <!-- <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'scheduling' }" @click="tab = 'scheduling'">
              Scheduling
            </div> -->
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'job' }" @click="tab = 'job'">
              Jobs
            </div>
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'profile' }" @click="tab = 'profile'">
              Intake Notes
            </div>
            <div class="col-lg-2 col-md-2 dashboard-button" :class="{ 'dashboard-button-active': tab == 'emails' }" @click="tab = 'emails'">
              Email Log
            </div>
          </div>

          <div v-if="tab == 'admin' && user.id">
            <panel :passedUser="user" @userUpdated="userUpdated()"></panel>
            <hr>
            <document-manager :user="user"></document-manager>
            <hr>
            <candidate-employer-relationship-manager :user="user"></candidate-employer-relationship-manager>
          </div>

          <div v-if="tab == 'application' && user.id">
            <!-- <application-view :user="user"></application-view>
            <hr>
            <button class="mylisting-button dark-button mt-4" @click="showEmployerApplicationFormModal()">Edit</button> -->
            <!-- <hr> -->
            <!-- <package-selection :user="user"></package-selection> -->

            <!-- <hr> -->
            <!-- <employer-documents :user="user"></employer-documents> -->
            <div style="margin-top: -80px; margin-bottom: -17.5vh;">
              <app-employer-dashboard :employerID="user.id"></app-employer-dashboard>
            </div>
          </div>

          <div v-if="tab == 'scheduling' && user.id">
            <employer-week-scheduler :user="user"></employer-week-scheduler>
          </div>

          <div v-if="tab == 'job' && user.id">
            <job-posting :user="user"></job-posting>
          </div>

          <div v-if="tab == 'documents' && user.id">
            <employer-documents :user="user"></employer-documents>
          </div>

          <div v-if="tab == 'profile' && user.id">
            <internal-profile :user="user" :userID="user.id"></internal-profile>
          </div>

          <div v-if="tab == 'emails' && user.id">
            <email-log :recipient="user"></email-log>
          </div>

          <!-- <div v-if="tab == 'profile'" style="margin-top: -80px; margin-bottom: -17.5vh;">
            <app-employer-dashboard :employerID="user.id"></app-employer-dashboard>
          </div> -->
          <hr>
          <!-- <button class="mylisting-button dark-button" @click="resetPassword(user)" style="">Reset Password</button> -->

          <!-- <button v-if="user.status != 'Active'" class="mylisting-button dark-button" @click="approveUser(user)" style="float: right;">Activate</button> -->
          <!-- <button v-if="user.status == 'Active'" class="mylisting-button secondary-button" @click="disapproveUser(user)" style="float: right;">Deactivate</button> -->
          <button class="mylisting-button secondary-button" @click="$modal.hide('employer-modal')" style="">Close</button>
          <!-- <button class="mylisting-button danger-button" @click="showDeleteUserModal(user)">Delete</button> -->
          <p class="mt-2" @click="showDeleteUserModal(user)" style="cursor: pointer;">Delete Client</p>
        </div>
      </modal>

      <!-- <modal name="employer-application-form-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">
          <family-form :user="user" @userUpdated="updateUser()"></family-form>
        </div>
      </modal> -->

      <modal name="delete-user-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">
          <h3>Are you sure you want to delete this user?</h3>
          <p>{{ user.first_name }} {{ user.last_name }}</p>
          <p>{{ user.email }}</p>
          <hr>
          <button class="mylisting-button secondary-button" @click="hideDeleteUserModal()" style="">Cancel</button>
          <button class="mylisting-button danger-button" @click="deleteUser(user)" style="float: right;">Delete</button>
        </div>
      </modal>

      <modal name="email-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">
          Mailing List: {{ mailingList.join(', ') }}
          <hr>
          <label style="margin-bottom: 0;">From Email</label>
          <input type="text" class="form-control mb-2" v-model="fromEmail" placeholder="From Email">
          <input type="text" class="form-control mb-2" v-model="emailSubject" placeholder="Subject">
          <textarea class="form-control" rows="5" v-model="emailMessage"></textarea>
          <div class="form-group form-check mb-1 mt-1">
            <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
            <label class="form-check-label" style="text-align: left; cursor: pointer;" @click="logMessage = !logMessage">
              Log email as note
            </label>
          </div>
          <hr>
          <button class="mylisting-button dark-button" style="" @click="sendEmail()">Send</button>
        </div>
      </modal>

    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  import Blog from './Blog'
  import CandidateProfile from '../candidates/CandidateProfile'
  import CandidateDashboard from '../candidates/Dashboard'
  import CandidateInterview from './CandidateInterview'
  import EmployerDashboard from '../employers/Dashboard'
  import MyEvents from '../events/MyEvents'
  import Events from './Events'
  import Agents from './tables/Agents'
  import MailingList from './MailingList'
  import Panel from './Panel'
  import Scheduler from './Scheduler'
  import ApplicationView from './ApplicationView'
  import InternalProfile from './InternalProfile'
  import StatusStats from './StatusStats'
  import EmailLog from './EmailLog'
  import EmployerDocuments from '../employers/documents/Documents'
  import EmployerWeekScheduler from '../employers/jobs/WeekScheduler'
  import PackageSelection from '../employers/profile/PackageSelection'
  import MasterCalendar from './MasterCalendar'
  import CandidateEmployerRelationshipManager from './CandidateEmployerRelationshipManager'
  import JobPosting from './functions/JobPosting'
  import EmailTemplates from './systems/EmailTemplates'
  import EmailFooters from './systems/EmailFooters'
  import InterviewTemplates from './systems/InterviewTemplates'
  import ResourceManager from './systems/ResourceManager'
  import DocumentTemplates from './systems/DocumentTemplates'
  import DocumentManager from './systems/DocumentManager'
  import Jobs from './tables/Jobs'
  import JobApplications from './tables/JobApplications'
  import FamilyForm from '../employers/applications/FamilyFormEdit'
  import AddUser from './functions/AddUser'

  export default {
    components: {
      appBlog: Blog,
      appCandidateProfile: CandidateProfile,
      CandidateDashboard,
      CandidateInterview,
      appEmployerDashboard: EmployerDashboard,
      appMyEvents: MyEvents,
      appEvents: Events,
      appAgents: Agents,
      appMailingList: MailingList,
      Panel,
      Scheduler,
      ApplicationView,
      InternalProfile,
      StatusStats,
      EmailLog,
      EmailTemplates,
      EmailFooters,
      InterviewTemplates,
      EmployerDocuments,
      EmployerWeekScheduler,
      PackageSelection,
      MasterCalendar,
      CandidateEmployerRelationshipManager,
      JobPosting,
      Jobs,
      JobApplications,
      ResourceManager,
      DocumentTemplates,
      DocumentManager,
      FamilyForm,
      AddUser,
    },
    data() {
      return {
        agent: {},

        candidates: [],
        employers: [],
        employerEmails: [],
        user: {},
        blogposts: [],

        // selector: 'Master Calendar',
        selector: 'Clients',
        selectorOptions: [
          // 'Snapshot',
          'Master Calendar',
          'Nannies', 'Clients', 'Jobs', 'Email Templates', 'Document Templates',
          // 'Email Footers',
          'Email Log', 'Interview Templates', 'Resource Manager', 'Administrators', 'Payments'],
        selectorOptions2: [
          'Nannies',
          // 'Clients',
          'Email Templates', 'Email Log', 'Interview Templates',
          // 'Administrators', 'Payments'
        ],
        tab: '',

        statusFilters: [],
        statusOptions: [],
        tagFilters: [],
        // tagOptions: [],
        positionFilters: [],
        liveinoutFilters: [],
        hideRejected: true,
        hideCompleted: true,

        employerStatusFilters: [],
        // employerStatusOptions: [],

        mailingList: [],
        fromEmail: "",
        emailSubject: "",
        emailMessage: "",
        logMessage: true,

        candidateSearch: "",
        clientSearch: "",
        languageSearch: "",
        stateSearch: "",
      }
    },
    created() {
      this.getAgent()
      this.getCandidates()
      this.getEmployers()
      // this.getBlogposts()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },3000)

      this.statusOptions = this.$store.getters.statusOptions
      // this.employerStatusOptions = this.$store.getters.employerStatuses
      // this.tagOptions = this.$store.getters.focusAreas
    },
    computed: {
      filteredCandidates() {
        var statusFilteredUsers = []
        // if (this.countryFilter != 'All') {
        if (this.statusFilters.length > 0) {
          for (var user in this.candidates) {
            // if (focusFilteredUsers[user].country == this.countryFilter) {
            if (this.statusFilters.includes(this.candidates[user].status)) {
              statusFilteredUsers.push(this.candidates[user])
            }
          }
        }
        else {
          statusFilteredUsers = this.candidates
        }

        var positionFilteredUsers = []
        if (this.positionFilters.length > 0) {
          for (var user in statusFilteredUsers) {
            for (var position in this.positionFilters) {
              if (statusFilteredUsers[user].multiselect2.includes(this.positionFilters[position])) {
                positionFilteredUsers.push(statusFilteredUsers[user])
                break
              }
            }
          }
        }
        else {
          positionFilteredUsers = statusFilteredUsers
        }

        var rejectionFilteredUsers = []
        if (this.hideRejected) {
          for (var user in positionFilteredUsers) {
            if (positionFilteredUsers[user].status != 'Rejected') {
              rejectionFilteredUsers.push(positionFilteredUsers[user])
            }
          }
        }
        else {
          rejectionFilteredUsers = positionFilteredUsers
        }

        // Filters by name or Email
        if (this.candidateSearch) {
          rejectionFilteredUsers = rejectionFilteredUsers.filter(user => {
            return (user.first_name + ' ' + user.last_name + ' ' + user.email).toLowerCase().includes(this.candidateSearch.toLowerCase())
          })
        }

        // Filters by language
        if (this.languageSearch) {
          rejectionFilteredUsers = rejectionFilteredUsers.filter(user => {
            return (user.selector2).toLowerCase().includes(this.languageSearch.toLowerCase())
          })
        }

        // Filters by state
        if (this.stateSearch) {
          rejectionFilteredUsers = rejectionFilteredUsers.filter(user => {
            return (user.provincestate).toLowerCase().includes(this.stateSearch.toLowerCase())
          })
        }

        // Filter by live in or out
        if (this.liveinoutFilters.length > 0) {
          rejectionFilteredUsers = rejectionFilteredUsers.filter(user => {
            return this.liveinoutFilters.includes(user.selector3)
          })
        }

        return rejectionFilteredUsers
      },
      filteredEmployers() {
        var statusFilteredUsers = []
        // if (this.countryFilter != 'All') {
        if (this.employerStatusFilters.length > 0) {
          for (var user in this.employers) {
            // if (focusFilteredUsers[user].country == this.countryFilter) {
            if (this.employerStatusFilters.includes(this.employers[user].status)) {
              statusFilteredUsers.push(this.employers[user])
            }
          }
        }
        else {
          statusFilteredUsers = this.employers
        }

        var rejectionFilteredUsers = []
        if (this.hideRejected) {
          for (var user in statusFilteredUsers) {
            if (statusFilteredUsers[user].status != 'Inactive' && statusFilteredUsers[user].status != 'Lost') {
              rejectionFilteredUsers.push(statusFilteredUsers[user])
            }
          }
        }
        else {
          rejectionFilteredUsers = statusFilteredUsers
        }

        var completionFilteredUsers = []
        if (this.hideCompleted) {
          for (var user in rejectionFilteredUsers) {
            if (rejectionFilteredUsers[user].status != 'Placement Fee Paid') {
              completionFilteredUsers.push(rejectionFilteredUsers[user])
            }
          }
        }
        else {
          completionFilteredUsers = rejectionFilteredUsers
        }

        // Filters by name or Email
        if (this.clientSearch) {
          completionFilteredUsers = completionFilteredUsers.filter(user => {
            return (user.first_name + ' ' + user.last_name + ' ' + user.email).toLowerCase().includes(this.clientSearch.toLowerCase())
          })
        }

        // return this.employers
        return completionFilteredUsers
      },
    },
    methods: {
      getAgent() {
        axios.get('/api/people/?id='+this.$store.getters.userID)
          .then(res => {
            console.log(res)
            this.agent = res.data[0]

            if (this.agent.category == 'candidates') {
              this.selector = 'Nannies'
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      getCandidates() {
        axios.get('/api/people/?is_candidate=true&agency='+this.$store.getters.agencyID)
          .then(res => {
            console.log(res)
            this.candidates = res.data
          })
          .catch(error => console.log(error))
      },
      getEmployers() {
        axios.get('/api/people/?is_employer=true&agency='+this.$store.getters.agencyID)
          .then(res => {
            console.log(res)
            this.employers = res.data

            this.employerEmails = this.employers.map(
            employer =>
              `${employer.employer_name} (${employer.email})`
            );
          })
          .catch(error => console.log(error))
      },
      // getBlogposts() {
      //   axios.get('/api/blogposts/?agency=4')
      //     .then(res => {
      //       console.log(res)
      //       this.blogposts = res.data
      //     })
      //     .catch(error => console.log(error))
      // },
      showCandidateModal(user) {
        this.user = user
        this.$modal.show('candidate-modal')
        this.tab = 'profile'
      },
      showEmployerModal(user) {
        this.user = user
        this.tab = 'application'
        this.$modal.show('employer-modal')
      },
      hideUserModal() {
        this.$modal.hide('candidate-modal')
        this.$modal.hide('employer-modal')
      },
      showDeleteUserModal(user) {
        this.user = user
        this.$modal.show('delete-user-modal')
      },
      hideDeleteUserModal() {
        this.$modal.hide('delete-user-modal')
      },
      deleteUser(user) {
        console.log('Deleting User: '.concat(user.id.toString()))
        axios.delete('/api/people/'.concat(user.id.toString()).concat('/'))
          .then(res => {
            console.log(res)
            if (user.is_candidate) {
              this.getCandidates()
            }
            else if (user.is_employer) {
              this.getEmployers()
            }
            // this.hideDeleteModal()
            // this.closeCandidateModal()
            this.$modal.hide('candidate-modal')
            this.$modal.hide('employer-modal')
            this.hideDeleteUserModal()
          })
          .catch(error => console.log(error))
      },
      approveUser(user) {
        axios.patch('/api/people/'.concat(user.id.toString()).concat('/'), {
          status: 'Active'
        })
          .then(res => {
            console.log(res)
            this.getEmployers()
          })
          .catch(error => console.log(error))
      },
      disapproveUser(user) {
        axios.patch('/api/people/'.concat(user.id.toString()).concat('/'), {
          status: 'New'
        })
          .then(res => {
            console.log(res)
            this.getEmployers()
          })
          .catch(error => console.log(error))
      },
      resetPassword(user) {

      },
      userUpdated() {
        this.getCandidates()
        // this.getEmployers()
      },
      updateUser() {
        this.getEmployers()
        this.getCandidates()

        axios.get(`/api/people/?id=${this.user.id}`)
          .then(res => {
            this.user = res.data[0]
            // this.$modal.hide('employer-application-form-modal')
            this.$modal.hide('employer-summary-form-modal')
            // this.$modal.show('employer-modal')
          })
          .catch(error => console.log(error))
      },
      showEmailModal() {
        this.mailingList = this.filteredCandidates.map(
          candidate => `${candidate.email}`
        );
        this.$modal.show('email-modal')
      },
      // showEmployerApplicationFormModal() {
      //   this.$modal.show('employer-application-form-modal')
      // },
      refresh() {
        this.getCandidates()
        this.getEmployers()
      },


      adminify(user) {
        //
        // Function for converting a candidate account into an admin account (just a workaround, not in production use)
        //
        axios.patch('/api/people/'+user.id.toString()+'/', {
          is_agent: true,
          is_candidate: false,
        })
          .then(res => {
            console.log(res)
            this.getCandidates()
          })
          .catch(error => {
            console.log(error)
          })
      },
      setteam(user) {
        axios.patch('/api/people/'+user.id.toString()+'/', {
          status: 'team',
          // first_name: 'Annalise',
          // last_name: 'Mathers',
        })
          .then(res => {
            console.log(res)
            this.getCandidates()
          })
          .catch(error => {
            console.log(error)
          })
      },
      changeEmail(user) {
        axios.patch('/api/people/'+user.id.toString()+'/', {
          // email: 'myrundash@gmail.com'
          email: 'pihcanada@pih.org'
        })
          .then(res => {
            console.log(res)
            this.getEmployers()
          })
          .catch(error => {
            console.log(error)
          })
      },
      clearStripeID() {
        axios.patch('/api/people/'+this.agent.id.toString()+'/', {
          stripe_customer_id: '',
          // stripe_customer_id: 'acct_1GDYUZIcCA8L7IlD',
        })
          .then(res => {
            console.log(res)
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateStats() {
        for (var candidate in this.candidates) {
          axios.patch(`/api/people/${this.candidates[candidate].id}/`, {
            numberArray: [0, 0, 0, 0]
          })
        }
      },
      sortAlpha(userType) {
        // Function sorts candidates/employers by last name

        function compare(a, b) {
          const nameA = a.last_name.toUpperCase()
          const nameB = b.last_name.toUpperCase()

          let comparison = 0
          if (nameA > nameB) {
            comparison = 1
          } else if (nameA < nameB) {
            comparison = -1
          }
          return comparison
        }

        userType.sort(compare)
      },
    }
  }
</script>

<style>
  .newEntryRow {
    font-weight: 700;
  }
  .activeEntryRow {
    /* background-color: var(--coredarkcolor) !important; */
    background-color: var(--agencycolor) !important;
    /* color: var(--corelightcolor); */
    font-weight: 700;
  }
  .table {
    /* font-size: 0.75rem; */
  }
</style>



// WEBPACK FOOTER //
// src/components/agents/Dashboard.vue